export const scrollWithOffset = (offset: number) => (el: HTMLElement) => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
  window.scrollTo({ top: yCoordinate + offset, behavior: "smooth" });
};
export const scrollWithNavOffset = scrollWithOffset(-100);

export const scrollWithNullOffset = scrollWithOffset(0);
